// @ts-nocheck
/**
 * PDP Scrambler Detail - Extended from PDPProductDetail
 * Adds personalization (nameplate) functionality
 */

const juicedPaidNameplateIsRejected = (value) => {
  if (!String(value || '').trim()) return false;
  const result = window.JuicedNameplateModeration?.evaluate(value);
  return !result || result.status === 'blocked';
};

class PDPScramblerDetail {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sectionId = sectionElement.dataset.sectionId || '';

    this.splideElement = this.section.querySelector('.scrambler-main-splide');
    this.galleryDotsContainer = this.section.querySelector('.scrambler-gallery-dots');
    this.imageGrid = this.section.querySelector('.scrambler-image-grid');
    this.variantPicker = this.section.querySelector('variant-picker');
    this.variantInput = this.section.querySelector('[name="id"]');
    this.productForm = this.section.querySelector('.product-form');

    this.variants = this.getVariantsData();
    this.currentVariant = this.getCurrentVariant();

    // Personalization state
    this.personalizationConfirmed = false;

    this.splide = null;
    this.init();
  }

  getVariantsData() {
    var el = document.getElementById('product-variants-' + this.sectionId);
    if (el) {
      try { return JSON.parse(el.textContent); } catch (e) {}
    }
    return [];
  }

  getCurrentVariant() {
    if (this.variantPicker) {
      var json = this.variantPicker.querySelector('script[type="application/json"]');
      if (json) {
        try { return JSON.parse(json.textContent); } catch (e) {}
      }
    }
    return null;
  }

  init() {
    // Gallery
    if (this.splideElement && window.Splide) {
      this.splide = new window.Splide(this.splideElement, {
        type: 'fade',
        perPage: 1,
        arrows: false,
        pagination: false,
        drag: true,
        speed: 500,
        rewind: true,
      });
      this.splide.mount();
      this.createGalleryDots();
      this.attachImageGridListeners();
      
      // Sync the gallery to the URL-specified variant on initial load.
      if (this.currentVariant) this.goToVariantImage(this.currentVariant);
    }

    if (!window.Splide && this.splideElement) {
      var self = this;
      window.addEventListener('load', function() { self.init(); });
      return;
    }

    this.attachVariantPickerListeners();
    this.attachAddOnListeners();
    this.attachPersonalizationListeners();
    if (this.section.dataset.productId === '7758039416909') this.attachPaidNameplate();
    this.attachFormSubmitHandler();
    this.applySwatchStates();
  }

  // ---- VARIANT PICKER ----

  attachVariantPickerListeners() {
    if (!this.variantPicker) return;

    this.variantPicker.addEventListener('variant-update', (event) => {
      var variant = event.detail?.variant;
      if (variant) this.onVariantChange(variant);
      this.applySwatchStates();
    });

    this.variantPicker.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      if (this._ignoreChange) return;

      var swatchGroup = event.target.dataset.swatchGroup;
      if (swatchGroup) this.selectGroupOption(swatchGroup);

      this.applySwatchStates();
      this.updateAddToCartForAvailability();

      // Update price when variant changes via radio click
      var variant = this.findVariantFromInputs();
      if (variant) this.onVariantChange(variant);
    });
  }

  applySwatchStates() {
    if (!this.variantPicker) return;

    this.variantPicker.querySelectorAll('.color-swatch-label').forEach((label) => {
      var input = label.querySelector('input[type="radio"]');
      if (input) label.classList.toggle('selected', input.checked);
    });

    this.variantPicker.querySelectorAll('.option-button-label').forEach((label) => {
      var input = label.querySelector('input[type="radio"]');
      if (input) label.classList.toggle('active', input.checked);
    });

    if (!this.variants || this.variants.length === 0) return;

    var fieldsets = this.variantPicker.querySelectorAll('[data-option-position]');
    if (fieldsets.length === 0) return;

    var selectedOptions = this.getSelectedOptions();
    var groupOptionIndex = -1;
    var firstGrouped = this.variantPicker.querySelector('input[data-swatch-group]');
    if (firstGrouped) {
      var groupVal = firstGrouped.dataset.swatchGroup;
      fieldsets.forEach((fs, idx) => {
        if (groupOptionIndex >= 0) return;
        var match = fs.querySelector('input[type="radio"][value="' + CSS.escape(groupVal) + '"]');
        if (match && !match.dataset.swatchGroup) groupOptionIndex = idx;
      });
    }

    var colorFieldsetIndex = firstGrouped
      ? parseInt(firstGrouped.closest('[data-option-position]')?.dataset.optionPosition || '1') - 1
      : -1;

    fieldsets.forEach((fieldset, fieldsetIndex) => {
      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        var swatchGroup = input.dataset.swatchGroup;
        var isAvailable;

        if (swatchGroup) {
          isAvailable = true;
        } else if (groupOptionIndex >= 0 && (fieldsetIndex === groupOptionIndex || fieldsetIndex === colorFieldsetIndex)) {
          isAvailable = this.variants.some((v) => v.available && v.options[fieldsetIndex] === input.value);
        } else if (groupOptionIndex >= 0) {
          var opts = [...selectedOptions];
          opts[colorFieldsetIndex] = null;
          isAvailable = this.isOptionValueAvailable(input.value, fieldsetIndex, opts);
        } else {
          isAvailable = this.isOptionValueAvailable(input.value, fieldsetIndex, selectedOptions);
        }

        var label = input.closest('label');
        if (label) {
          label.classList.toggle('unavailable', !isAvailable);
          if (isAvailable) label.classList.remove('disabled');
        }
        if (swatchGroup && input.disabled) input.disabled = false;
      });
    });
  }

  selectGroupOption(groupValue) {
    if (!this.variantPicker) return;
    var allInputs = this.variantPicker.querySelectorAll('input[type="radio"]');
    for (var input of allInputs) {
      if (input.dataset.swatchGroup) continue;
      if (input.value !== groupValue || input.checked) continue;
      input.checked = true;
      var label = input.closest('label');
      if (label) {
        label.closest('fieldset')?.querySelectorAll('.option-button-label').forEach(l => l.classList.remove('active'));
        label.classList.add('active');
      }
      this._ignoreChange = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this._ignoreChange = false;
      break;
    }
  }

  updateAddToCartForAvailability() {
    // If the original <variant-picker> isn't in the DOM (custom template
    // uses .custom-variant-picker instead), bail and let the custom inline
    // script drive the button state.
    if (!this.variantPicker) return;
    var btn = this.section.querySelector('.product-add-to-cart');
    if (!btn) return;
    var variant = this.findVariantFromInputs();
    if (variant && this.variantInput) this.variantInput.value = variant.id;
    if (variant && variant.available) {
      btn.disabled = false;
      btn.textContent = btn.dataset.addText || 'Add to Cart';
    } else if (variant && !variant.available) {
      btn.disabled = true;
      btn.textContent = btn.dataset.soldOutText || 'Sold Out';
    } else {
      btn.disabled = true;
      btn.textContent = 'Unavailable';
    }
  }

  getSelectedOptions() {
    var opts = [];
    this.variantPicker.querySelectorAll('[data-option-position]').forEach((fs) => {
      var checked = fs.querySelector('input[type="radio"]:checked');
      opts.push(checked ? checked.value : null);
    });
    return opts;
  }

  isOptionValueAvailable(optionValue, optionIndex, selectedOptions) {
    return this.variants.some((variant) => {
      if (variant.options[optionIndex] !== optionValue) return false;
      if (!variant.available) return false;
      for (var i = 0; i < selectedOptions.length; i++) {
        if (i === optionIndex) continue;
        if (selectedOptions[i] && variant.options[i] !== selectedOptions[i]) return false;
      }
      return true;
    });
  }

  findVariantFromInputs() {
    if (!this.variantPicker) return null;
    var selectedOptions = this.getSelectedOptions();
    if (selectedOptions.length === 0 || selectedOptions.every(v => v === null)) return null;
    return this.variants.find((variant) => {
      return variant.options.every((option, index) => {
        return selectedOptions[index] === null || option === selectedOptions[index];
      });
    }) || null;
  }

  onVariantChange(variant) {
    if (this.variantInput) this.variantInput.value = variant.id;
    this.updatePriceDisplay(variant);
    this.updateAddToCartButton(variant);
    this.updateURL(variant);
    this.goToVariantImage(variant);
    this.updateShipDate(variant);
  }

  updateShipDate(variant) {
    if (!variant) return;
    var shipEl = this.section.querySelector('[data-ship-date]');
    var mapEl = this.section.querySelector('[data-ship-date-map]');
    if (!shipEl || !mapEl) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    var value = map[String(variant.id)];
    if (value && String(value).trim() !== '') {
      shipEl.textContent = value;
      shipEl.style.display = '';
    } else {
      shipEl.textContent = '';
      shipEl.style.display = 'none';
    }
  }

  updatePriceDisplay(variant) {
    this.currentVariant = variant;

    // Update ALL pricing containers (mobile header + main)
    var containers = this.section.querySelectorAll('.product-pricing');
    containers.forEach(function(container) {
      container.dataset.basePrice = variant.price;

      var salePrice = container.querySelector('.price--sale, .price--current');
      var originalPrice = container.querySelector('.price--original:not(.price--with-upgrades)');
      var badge = container.querySelector('.product-discount-badge:not(.product-savings-badge)');

      if (salePrice) {
        salePrice.textContent = this.formatMoney(variant.price);
        salePrice.dataset.price = variant.price;
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (originalPrice) {
          originalPrice.textContent = this.formatMoney(variant.compare_at_price);
          originalPrice.dataset.comparePrice = variant.compare_at_price;
          originalPrice.style.display = '';
        }
        if (badge) {
          badge.textContent = 'Save ' + this.formatMoney(variant.compare_at_price - variant.price);
          badge.style.display = '';
        }
      } else {
        if (originalPrice) originalPrice.style.display = 'none';
        if (badge) badge.style.display = 'none';
      }
    }.bind(this));

    this.updatePriceWithUpgrades();
  }

  updateAddToCartButton(variant) {
    var btn = this.section.querySelector('.product-add-to-cart');
    if (!btn) return;
    if (variant.available) {
      btn.disabled = false;
      btn.textContent = btn.dataset.addText || 'Add to Cart';
    } else {
      btn.disabled = true;
      btn.textContent = btn.dataset.soldOutText || 'Sold Out';
    }
  }

  updateURL(variant) {
    if (!history.replaceState || !variant) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({ variant: variant.id }, '', url.toString());
  }

  formatMoney(cents) {
    const n = Number(cents);
    if (!isFinite(n)) return '';
    return '$' + (n / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  // ---- GALLERY DOTS ----

  createGalleryDots() {
    if (!this.splide || !this.galleryDotsContainer) return;
    var total = this.splide.length;
    var splide = this.splide;
    var container = this.galleryDotsContainer;

    container.innerHTML = '';
    var track = document.createElement('div');
    track.className = 'scrambler-gallery-dots-track';
    container.appendChild(track);

    var slideImgs = this.splideElement.querySelectorAll('.splide__slide img');

    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.className = 'scrambler-gallery-dot' + (i === 0 ? ' is-active' : '');
      dot.type = 'button';
      dot.dataset.index = i;

      var slideImg = slideImgs[i];
      if (slideImg) {
        var thumb = document.createElement('img');
        thumb.className = 'scrambler-gallery-dot__img';
        var thumb1x = slideImg.getAttribute('data-thumb-url') || slideImg.src;
        var thumb2x = slideImg.getAttribute('data-thumb-url-2x');
        thumb.src = thumb1x;
        if (thumb2x) {
          thumb.srcset = thumb1x + ' 1x, ' + thumb2x + ' 2x';
        }
        thumb.alt = '';
        thumb.loading = 'lazy';
        thumb.decoding = 'async';
        dot.appendChild(thumb);
      }

      dot.addEventListener('click', function() {
        if (track.dataset.dragMoved === '1') return;
        splide.go(parseInt(this.dataset.index));
      });
      track.appendChild(dot);
    }

    (function attachDragScroll() {
      var isDown = false;
      var startX = 0;
      var startY = 0;
      var startScroll = 0;
      var dragging = false;
      var DRAG_THRESHOLD = 5;

      track.addEventListener('pointerdown', function(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        isDown = true;
        dragging = false;
        startX = e.clientX;
        startY = e.clientY;
        startScroll = track.scrollLeft;
        track.dataset.dragMoved = '0';
      });

      track.addEventListener('pointermove', function(e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!dragging && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
          if (Math.abs(dx) > Math.abs(dy)) {
            dragging = true;
            track.dataset.dragMoved = '1';
          } else {
            isDown = false;
            return;
          }
        }
        if (dragging) {
          e.preventDefault();
          track.scrollLeft = startScroll - dx;
        }
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        var wasDragging = dragging;
        dragging = false;
        if (wasDragging) {
          setTimeout(function() { track.dataset.dragMoved = '0'; }, 0);
        } else {
          track.dataset.dragMoved = '0';
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      window.addEventListener('pointerup', endDrag);
    })();

    splide.on('moved', function(newIndex) {
      track.querySelectorAll('.scrambler-gallery-dot').forEach(function(d, idx) {
        d.classList.toggle('is-active', idx === newIndex);
      });
    });
  }

  // ---- LIFESTYLE LIGHTBOX ----
  // The bottom grid is now a separate "lifestyle photos" gallery (sourced
  // from product.metafields.custom.lifestyle_images). Clicking a thumbnail
  // opens it in a full-screen lightbox with prev / next / close + keyboard.
  attachImageGridListeners() {
    if (!this.imageGrid) return;
    var self = this;
    var thumbs = Array.from(this.imageGrid.querySelectorAll('.scrambler-grid-thumb'));
    if (!thumbs.length) return;

    var lightbox = this.section.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var imgEl = lightbox.querySelector('[data-lightbox-image]');
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');

    var slides = thumbs.map(function(thumb) {
      return {
        src: thumb.getAttribute('data-lightbox-src') || thumb.querySelector('img')?.src,
        srcset: thumb.getAttribute('data-lightbox-srcset') || '',
        alt: thumb.getAttribute('data-lightbox-alt') || ''
      };
    });

    var currentIndex = 0;

    function render(i) {
      currentIndex = (i + slides.length) % slides.length;
      var slide = slides[currentIndex];
      if (imgEl) {
        imgEl.src = slide.src;
        if (slide.srcset) imgEl.setAttribute('srcset', slide.srcset);
        else imgEl.removeAttribute('srcset');
        imgEl.alt = slide.alt;
      }
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + slides.length;
    }

    function open(i) {
      render(i || 0);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') render(currentIndex - 1);
      else if (e.key === 'ArrowRight') render(currentIndex + 1);
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        open(i);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function() { render(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { render(currentIndex + 1); });

    // Click outside the figure (on the dark backdrop) closes the lightbox
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) close();
    });
  }

  // Go to the carousel slide that matches a variant's featured image
  goToVariantImage(variant) {
    if (!this.splide || !variant || !variant.featured_media) return;
    var mediaId = variant.featured_media.id;
    var slides = this.section.querySelectorAll('.scrambler-main-splide .splide__slide');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && img.dataset.mediaId && parseInt(img.dataset.mediaId) === mediaId) {
        this.splide.go(i);
        return;
      }
    }
  }

  // ---- ADD-ONS ----

  attachAddOnListeners() {
    this.section.querySelectorAll('.free-item-checkbox').forEach((cb) => {
      cb.addEventListener('change', (e) => {
        var label = e.target.closest('.pdp-scrambler-addon-item');
        if (label) label.classList.toggle('is-checked', e.target.checked);
      });
    });

    this.section.querySelectorAll('.upgrade-item-checkbox').forEach((cb) => {
      cb.addEventListener('change', (e) => {
        var label = e.target.closest('.pdp-scrambler-addon-item');
        if (label) label.classList.toggle('is-checked', e.target.checked);
        this.updatePriceWithUpgrades();
      });
    });

    this.updatePriceWithUpgrades();
  }

  updatePriceWithUpgrades() {
    var container = this.section.querySelector('.product-information .product-pricing');
    if (!container) return;
    var hasSalePrice = container.querySelector('.price--sale') !== null;
    if (hasSalePrice) return;

    var basePrice = parseInt(container.dataset.basePrice) || (this.currentVariant?.price) || 0;
    var upgradeTotal = 0;
    this.section.querySelectorAll('.upgrade-item-checkbox:checked').forEach((cb) => {
      upgradeTotal += parseInt(cb.dataset.itemPriceValue) || 0;
    });

    var currentPrice = container.querySelector('.price--current');
    var upgradeOriginal = container.querySelector('.price--with-upgrades');
    var savingsBadge = container.querySelector('.product-savings-badge');
    if (!currentPrice) return;

    if (upgradeTotal > 0) {
      currentPrice.textContent = this.formatMoney(basePrice + upgradeTotal);
      if (upgradeOriginal) { upgradeOriginal.textContent = this.formatMoney(basePrice); upgradeOriginal.style.display = ''; }
      if (savingsBadge) { savingsBadge.textContent = '+' + this.formatMoney(upgradeTotal) + ' in upgrades'; savingsBadge.style.display = ''; }
    } else {
      currentPrice.textContent = this.formatMoney(basePrice);
      if (upgradeOriginal) upgradeOriginal.style.display = 'none';
      if (savingsBadge) savingsBadge.style.display = 'none';
    }
  }

  // ---- PERSONALIZATION ----

  attachPersonalizationListeners() {
    var section = this.section;
    var radio = section.querySelector('.pdp-personalization-radio');
    var fields = section.querySelector('.pdp-personalization-fields');
    var textInput = section.querySelector('.pdp-personalization-input');
    var charCount = section.querySelector('.pdp-personalization-char-count');
    var termsCheckbox = section.querySelector('.pdp-personalization-terms-checkbox');
    var termsLink = section.querySelector('.pdp-personalization-terms-link');
    var modalOverlay = section.querySelector('.pdp-terms-modal-overlay');
    var modalAcceptBtn = section.querySelector('.pdp-terms-modal-accept');
    var modalCancelBtn = section.querySelector('.pdp-terms-modal-cancel');
    var modalCloseBtn = section.querySelector('.pdp-terms-modal-close');
    var modalAcceptCheckbox = section.querySelector('.pdp-terms-modal-accept-checkbox');
    var self = this;

    if (!radio || !fields) return;

    // Fields are always visible (per Figma)
    fields.classList.add('is-visible');

    // Radio can only be checked when terms + letter fill are both set
    var styleSelect = section.querySelector('.pdp-personalization-select[data-field="letter-style"]');

    // ---- Custom dropdown wiring (replaces the native <select> with a styled
    // listbox so we can paint the yellow-green hover highlight) ----
    var customSelect = section.querySelector('.pdp-custom-select');
    if (customSelect && styleSelect) {
      var toggle = customSelect.querySelector('.pdp-custom-select__toggle');
      var label = customSelect.querySelector('.pdp-custom-select__label');
      var list = customSelect.querySelector('.pdp-custom-select__list');
      var options = list ? Array.from(list.querySelectorAll('.pdp-custom-select__option')) : [];
      var placeholderText = label ? (label.getAttribute('data-placeholder') || label.textContent) : '';

      function closeCustom() {
        customSelect.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
      function openCustom() {
        customSelect.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
      function pickOption(opt) {
        if (!opt || opt.classList.contains('is-unavailable')) return;
        options.forEach(function(o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var val = opt.getAttribute('data-value') || '';
        styleSelect.value = val;
        if (label) label.textContent = opt.textContent;
        customSelect.classList.toggle('is-selected', !!val);
        // Trigger native change so existing listeners (radio state, pulse clear, etc.) fire
        styleSelect.dispatchEvent(new Event('change', { bubbles: true }));
        closeCustom();
      }

      if (toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          if (customSelect.classList.contains('is-open')) closeCustom();
          else openCustom();
        });
      }

      options.forEach(function(opt) {
        opt.addEventListener('click', function(e) {
          e.stopPropagation();
          pickOption(opt);
        });
      });

      document.addEventListener('click', function(e) {
        if (!customSelect.contains(e.target)) closeCustom();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeCustom();
      });

      // Reflect initial state (if the native select has a value preset)
      if (styleSelect.value) {
        var initial = options.find(function(o) { return o.getAttribute('data-value') === styleSelect.value; });
        if (initial) pickOption(initial);
      }
    }

    function canCheckRadio() {
      var hasName = textInput && textInput.value.trim().length > 0;
      var hasStyle = styleSelect && styleSelect.value;
      var hasTerms = termsCheckbox && termsCheckbox.checked;
      return hasName && hasStyle && hasTerms;
    }

    function markEmptyFields() {
      // Flag empty required fields with a class so CSS can paint them grey
      if (textInput) {
        textInput.classList.toggle('needs-value', !textInput.value.trim());
      }
      if (styleSelect) {
        styleSelect.classList.toggle('needs-value', !styleSelect.value);
      }
      if (termsCheckbox) {
        var termsWrap = termsCheckbox.closest('.pdp-personalization-terms-wrap');
        if (termsWrap) termsWrap.classList.toggle('needs-value', !termsCheckbox.checked);
      }
    }

    function updateRadioState() {
      markEmptyFields();
      if (canCheckRadio()) {
        radio.disabled = false;
        radio.classList.remove('is-disabled');
      } else {
        radio.disabled = true;
        radio.checked = false;
        radio.classList.add('is-disabled');
      }
    }

    // Listen for changes on all required fields
    [textInput, styleSelect, termsCheckbox].forEach(function(el) {
      if (el) {
        el.addEventListener('input', updateRadioState);
        el.addEventListener('change', updateRadioState);
      }
    });

    // Initial state - radio disabled
    updateRadioState();

    var errorEl = section.querySelector('.pdp-personalization-error');

    function showError(msg) {
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.classList.add('is-visible');
      }
    }

    function hideError() {
      if (errorEl) {
        errorEl.classList.remove('is-visible');
      }
    }

    function pulseEmptyFields() {
      var targets = [];
      if (textInput && !textInput.value.trim()) targets.push(textInput);
      if (styleSelect && !styleSelect.value) targets.push(styleSelect);
      if (termsCheckbox && !termsCheckbox.checked) {
        var termsWrap = termsCheckbox.closest('.pdp-personalization-terms-wrap');
        if (termsWrap) targets.push(termsWrap);
      }
      targets.forEach(function(el) {
        el.classList.remove('is-pulsing');
        // Force reflow so the animation restarts on repeat clicks
        // eslint-disable-next-line no-unused-expressions
        el.offsetWidth;
        el.classList.add('is-pulsing');
      });
      setTimeout(function() {
        targets.forEach(function(el) { el.classList.remove('is-pulsing'); });
      }, 1200);
    }

    // When the radio is `disabled` the input swallows clicks silently.
    // Listen on the parent <label> so the pulse + error still trigger.
    var radioRow = radio.closest('.pdp-personalization-radio-row') || radio;
    radioRow.addEventListener('click', function(e) {
      if (!canCheckRadio()) {
        e.preventDefault();
        pulseEmptyFields();
        var errors = [];
        if (!textInput || !textInput.value.trim()) errors.push('Please enter a name');
        if (!styleSelect || !styleSelect.value) errors.push('please select a letter fill option');
        if (!termsCheckbox || !termsCheckbox.checked) errors.push('and accept the terms');
        showError(errors.join(', ') + '.');
      } else {
        hideError();
      }
    });

    // Hide error when all requirements are met
    [textInput, styleSelect, termsCheckbox].forEach(function(el) {
      if (el) {
        el.addEventListener('input', function() {
          if (canCheckRadio()) hideError();
        });
        el.addEventListener('change', function() {
          if (canCheckRadio()) hideError();
        });
      }
    });

    // Letter mask: allow only letters, numbers, and spaces in the name input
    if (textInput) {
      textInput.addEventListener('input', function(e) {
        var cleaned = textInput.value.replace(/[^A-Za-z0-9 ]/g, '');
        if (textInput.value !== cleaned) {
          textInput.value = cleaned;
        }
      });
    }

    // Description Read More / Show Less toggle
    var descWrap = section.querySelector('.pdp-personalization-description');
    var descToggle = section.querySelector('.pdp-personalization-description-toggle');
    if (descWrap && descToggle) {
      descToggle.addEventListener('click', function() {
        var expanded = descToggle.dataset.expanded === 'true';
        if (expanded) {
          descWrap.classList.add('is-collapsed');
          descToggle.textContent = 'Read More';
          descToggle.dataset.expanded = 'false';
        } else {
          descWrap.classList.remove('is-collapsed');
          descToggle.textContent = 'Show Less';
          descToggle.dataset.expanded = 'true';
        }
      });
    }

    // Character count
    if (textInput && charCount) {
      var maxLen = parseInt(textInput.getAttribute('maxlength')) || 12;
      textInput.addEventListener('input', function() {
        charCount.textContent = textInput.value.length + '/' + maxLen;
      });
    }

    // Terms link opens modal
    if (termsLink && modalOverlay) {
      termsLink.addEventListener('click', function(e) {
        e.preventDefault();
        modalOverlay.classList.add('is-open');
        if (modalAcceptCheckbox) modalAcceptCheckbox.checked = false;
      });
    }

    // Terms checkbox opens modal
    if (termsCheckbox && modalOverlay) {
      termsCheckbox.addEventListener('change', function() {
        if (termsCheckbox.checked && !self.personalizationConfirmed) {
          termsCheckbox.checked = false;
          modalOverlay.classList.add('is-open');
          if (modalAcceptCheckbox) modalAcceptCheckbox.checked = false;
        }
      });
    }

    // Modal accept
    if (modalAcceptBtn && modalOverlay) {
      modalAcceptBtn.addEventListener('click', function() {
        if (modalAcceptCheckbox && !modalAcceptCheckbox.checked) return;
        self.personalizationConfirmed = true;
        if (termsCheckbox) termsCheckbox.checked = true;
        modalOverlay.classList.remove('is-open');
      });
    }

    // Modal cancel
    if (modalCancelBtn && modalOverlay) {
      modalCancelBtn.addEventListener('click', function() {
        self.personalizationConfirmed = false;
        if (termsCheckbox) termsCheckbox.checked = false;
        modalOverlay.classList.remove('is-open');
      });
    }

    // Modal close X
    if (modalCloseBtn && modalOverlay) {
      modalCloseBtn.addEventListener('click', function() {
        modalOverlay.classList.remove('is-open');
      });
    }

    // Close modal on overlay click
    if (modalOverlay) {
      modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
          modalOverlay.classList.remove('is-open');
        }
      });
    }
  }

  getPersonalizationItem() {
    var radio = this.section.querySelector('.pdp-personalization-radio');
    if (!radio || !radio.checked) return null;

    var textInput = this.section.querySelector('.pdp-personalization-input');
    var styleSelect = this.section.querySelector('.pdp-personalization-select[data-field="letter-style"]');
    var nameplateVariantId = this.section.querySelector('[data-nameplate-variant-id]');

    if (!nameplateVariantId) return null;

    var name = textInput ? textInput.value.trim() : '';
    var letterStyle = styleSelect ? styleSelect.value : '';

    var properties = {
      'Name': name,
      'Letter Fill': letterStyle,
      '_note': nameplateVariantId.dataset.nameplateNote || 'Ships in individual box, within 3 weeks'
    };

    // If the style select has a data-variant-id on its selected option, use that instead
    var variantIdToUse = parseInt(nameplateVariantId.dataset.nameplateVariantId);
    if (styleSelect && styleSelect.selectedIndex >= 0) {
      var selectedOption = styleSelect.options[styleSelect.selectedIndex];
      if (selectedOption && selectedOption.dataset.variantId) {
        variantIdToUse = parseInt(selectedOption.dataset.variantId);
      }
    }

    return {
      id: variantIdToUse,
      quantity: 1,
      properties: properties
    };
  }

  validatePersonalization() {
    var radio = this.section.querySelector('.pdp-personalization-radio');
    if (!radio || !radio.checked) return true; // Not selected, no validation needed

    var errorEl = this.section.querySelector('.pdp-personalization-error');
    var textInput = this.section.querySelector('.pdp-personalization-input');
    var styleSelect = this.section.querySelector('.pdp-personalization-select[data-field="letter-style"]');
    var termsCheckbox = this.section.querySelector('.pdp-personalization-terms-checkbox');

    var errors = [];
    if (!textInput || !textInput.value.trim()) errors.push('Please enter a name.');
    if (styleSelect && !styleSelect.value) errors.push('Please select a letter fill option.');
    if (termsCheckbox && !termsCheckbox.checked) errors.push('Please accept the personalization terms.');

    if (errors.length > 0 && errorEl) {
      errorEl.textContent = errors[0];
      errorEl.classList.add('is-visible');
      return false;
    }

    if (errorEl) errorEl.classList.remove('is-visible');
    return true;
  }


  attachPaidNameplate() {
    const field = this.section.querySelector('.custom-nameplate-input');
    const preview = this.section.querySelector('[data-paid-nameplate-preview]');
    const svgText = preview?.querySelector('[data-nameplate-preview-text]');
    const censor = preview?.querySelector('[data-nameplate-preview-censor]');
    const hint = preview?.querySelector('[data-nameplate-preview-hint]');
    const visual = preview?.querySelector('.nameplate-preview__visual');
    const error = this.section.querySelector('[data-paid-nameplate-error]');
    const terms = this.section.querySelector('.custom-nameplate-terms-checkbox');
    const termsError = this.section.querySelector('[data-paid-nameplate-terms-error]');
    if (!field) return;
    const render = () => {
      const typed = field.value.trim();
      const decision = window.JuicedNameplateModeration?.evaluate(typed);
      const denied = Boolean(typed) && juicedPaidNameplateIsRejected(typed);
      const review = Boolean(typed) && decision?.status === 'review';
      field.setAttribute('aria-invalid', denied ? 'true' : 'false');
      if (error) {
        error.textContent = denied ? 'This engraving contains language we cannot accept. Please choose another name or phrase.'
          : review ? 'This engraving may require Juiced review before production. We may contact you.' : '';
        error.style.color = review ? '#855600' : '#b42318';
        error.hidden = !denied && !review;
      }
      if (!preview || !svgText) return;
      const display = denied ? '' : (typed ? typed.toUpperCase() : 'YOUR NAME');
      svgText.textContent = display;
      preview.classList.toggle('nameplate-preview--censored', denied);
      if (censor) censor.hidden = !denied;
      svgText.setAttribute('font-size', '94');
      const width = typeof svgText.getComputedTextLength === 'function' ? svgText.getComputedTextLength() : 0;
      if (width > 760) svgText.setAttribute('font-size', String(Math.max(34, Math.floor(94 * 760 / width))));
      if (hint) hint.textContent = denied
        ? 'This engraving cannot be personalized. Choose another name to continue.'
        : review ? 'Review required before production; Juiced may contact you. Illustrative preview only.'
        : 'Illustrative preview only. Final engraving font and finish may vary.';
      if (visual) visual.setAttribute('aria-label', denied
        ? 'Nameplate preview censored because the engraving contains disallowed language'
        : typed ? 'Approximate engraving preview: ' + display : 'Enter a name to preview your engraving');
    };
    field.addEventListener('input', render);
    field.addEventListener('change', render);
    if (terms && termsError) {
      terms.addEventListener('change', () => { if (terms.checked) termsError.hidden = true; });
    }
    render();
    if (document.fonts?.ready) document.fonts.ready.then(render).catch(() => {});
  }

  validatePaidNameplate() {
    if (this.section.dataset.productId !== '7758039416909') return true;
    const field = this.section.querySelector('.custom-nameplate-input');
    const error = this.section.querySelector('[data-paid-nameplate-error]');
    const terms = this.section.querySelector('.custom-nameplate-terms-checkbox');
    const termsError = this.section.querySelector('[data-paid-nameplate-terms-error]');
    const name = field?.value.trim() || '';
    const max = Number(field?.maxLength) > 0 ? Number(field.maxLength) : 12;
    let message = '';
    if (!name || Array.from(name).length > max) {
      message = 'Enter a valid engraving of up to ' + max + ' characters.';
    } else if (juicedPaidNameplateIsRejected(name)) {
      message = 'This engraving contains language we cannot accept. Please choose another name or phrase.';
    }
    const isReview = !message && window.JuicedNameplateModeration?.evaluate(name)?.status === 'review';
    if (error) {
      error.textContent = message || (isReview ? 'This engraving may require Juiced review before production. We may contact you.' : '');
      error.style.color = isReview ? '#855600' : '#b42318';
      error.hidden = !message && !isReview;
    }
    if (field) field.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (termsError) {
      termsError.textContent = !terms?.checked ? 'Please accept the customization terms and conditions.' : '';
      termsError.hidden = Boolean(terms?.checked);
    }
    if (message) { field?.focus(); return false; }
    if (!terms?.checked) { terms?.focus(); return false; }
    return true;
  }

  // ---- FORM SUBMIT ----

  attachFormSubmitHandler() {
    if (!this.productForm) return;

    this.productForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      var addToCartBtn = this.section.querySelector('.product-add-to-cart');
      var currentVariant = this.findVariantFromInputs();

      // Fallback: if the standard <variant-picker> isn't present (custom
      // template uses .custom-variant-picker), resolve the variant from the
      // form's hidden input id + the variants JSON.
      if (!currentVariant && this.variantInput && this.variants && this.variants.length) {
        var vid = parseInt(this.variantInput.value, 10);
        if (vid) {
          currentVariant = this.variants.find(function (v) { return v.id === vid; }) || null;
        }
      }

      if (!currentVariant || !currentVariant.available) {
        if (addToCartBtn) addToCartBtn.textContent = currentVariant ? 'Sold Out' : 'Unavailable';
        return;
      }

      // Validate personalization if selected
      if (!this.validatePersonalization()) return;
      if (!this.validatePaidNameplate()) return;

      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Adding...';
      }

      try {
        // Build items with main product first so it appears on top in the
        // cart drawer list ahead of upgrades / personalization.
        var itemsToAdd = [];

        var mainProperties = { _is_main_product: 'true' };
        if (this.section.dataset.productId === '7758039416909' && window.JuicedNameplateModeration?.evaluate(this.section.querySelector('.custom-nameplate-input')?.value)?.status === 'review') {
          mainProperties._juiced_nameplate_review = 'Pending manual review';
        }

        // Collect any properties[*] inputs rendered inside the form (e.g.
        // the Custom Nameplate block). Shopify natively attaches these on
        // standard form submit; since we're using /cart/add.js here, we
        // forward them manually.
        if (this.productForm) {
          this.productForm.querySelectorAll('input[name^="properties["]').forEach((input) => {
            var m = input.name.match(/^properties\[(.+?)\]$/);
            if (!m) return;
            var key = m[1];
            var val = (input.value || '').trim();
            if (val) mainProperties[key] = val;
          });
        }

        // Ship time for the order email is read DIRECTLY from the variant
        // metafield (custom.order_confirmation_ship_time) inside the Order
        // Confirmation notification template — notification Liquid supports
        // line.variant.metafields per line. So we intentionally do NOT attach
        // it as a line-item property here: a non-underscore property would show
        // at checkout, and an underscore one is hidden from the email too.
        // Reading the metafield live keeps it off checkout entirely.

        var checkedFreeItems = this.section.querySelectorAll('.free-item-checkbox:checked');
        checkedFreeItems.forEach((cb, i) => {
          var name = cb.dataset.itemName || '';
          if (name) {
            mainProperties['_free_' + (i + 1) + '_name'] = name;
            mainProperties['_free_' + (i + 1) + '_image'] = cb.dataset.itemImage || '';
            mainProperties['_free_' + (i + 1) + '_price'] = cb.dataset.itemPrice || '';
          }
        });
        itemsToAdd.push({
          id: parseInt(currentVariant.id),
          quantity: 1,
          properties: mainProperties
        });

        // Push free items as their own line items so they reach checkout.
        // Only items with a linked variant ID (mapped to a $0 product) are added.
        checkedFreeItems.forEach((cb) => {
          var freeVariantId = parseInt(cb.dataset.variantId, 10);
          if (!freeVariantId) return;
          var freeProps = { _free_with: currentVariant.id.toString() };
          // Capture optional personalization name typed into this item's input
          var wrap = cb.closest('.product-add-ons-item-wrapper');
          var nameInput = wrap ? wrap.querySelector('.product-add-ons-name-input') : null;
          if (nameInput && nameInput.value.trim()) {
            freeProps['Name'] = nameInput.value.trim();
          }
          itemsToAdd.push({
            id: freeVariantId,
            quantity: 1,
            properties: freeProps
          });
        });

        var checkedUpgrades = this.section.querySelectorAll('.upgrade-item-checkbox:checked');
        checkedUpgrades.forEach((cb) => {
          var variantId = parseInt(cb.dataset.variantId, 10);
          if (!variantId) return;
          itemsToAdd.push({ id: variantId, quantity: 1 });
        });

        var personalizationItem = this.getPersonalizationItem();
        if (personalizationItem) {
          itemsToAdd.push(personalizationItem);
        }

        // Add everything in one request so Shopify preserves the array order
        var addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        if (!addResponse.ok) {
          var addError = await addResponse.json().catch(function() { return {}; });
          console.error('Cart add failed:', addResponse.status, addError);
          throw new Error(addError.description || addError.message || 'Failed to add to cart');
        }

        // Note: the cart drawer template renders main-product line items
        // first (see snippets/cart-drawer-juiced.liquid), so no client-side
        // reordering is required here.

        this.onAddToCartSuccess();
      } catch (error) {
        console.error('Add to cart error:', error);
        if (addToCartBtn) {
          addToCartBtn.textContent = 'Error - Try Again';
          setTimeout(() => {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = addToCartBtn.dataset.addText || 'Add to Cart';
          }, 2000);
        }
      }
    });
  }

  async onAddToCartSuccess() {
    var btn = this.section.querySelector('.product-add-to-cart');
    if (btn) {
      btn.textContent = 'Added!';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = btn.dataset.addText || 'Add to Cart';
      }, 1500);
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    await this.refreshCartDrawer();

    var cartDrawer = document.getElementById('CartDrawer');
    var cartOverlay = document.getElementById('CartDrawerOverlay');
    if (cartDrawer) { cartDrawer.classList.add('active'); cartDrawer.setAttribute('aria-hidden', 'false'); }
    if (cartOverlay) cartOverlay.classList.add('active');

    this.updateCartCount();
  }

  async refreshCartDrawer() {
    try {
      var response = await fetch(window.location.pathname + '?sections=cart-drawer-juiced');
      if (!response.ok) throw new Error('Failed to fetch cart drawer');
      var data = await response.json();
      var html = data['cart-drawer-juiced'];
      if (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.getElementById('CartItems');
        var currentItems = document.getElementById('CartItems');
        if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

        var newTotal = doc.getElementById('CartTotal');
        var currentTotal = document.getElementById('CartTotal');
        if (newTotal && currentTotal) currentTotal.textContent = newTotal.textContent;

        var newFooter = doc.querySelector('.cart-drawer-footer');
        var currentFooter = document.querySelector('.cart-drawer-footer');
        if (newFooter && currentFooter) currentFooter.className = newFooter.className;

        this.attachCartDrawerListeners();
      }
    } catch (error) {
      console.error('Failed to refresh cart drawer:', error);
    }
  }

  attachCartDrawerListeners() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;
    var self = this;
    cartDrawer.querySelectorAll('[data-action="decrease-quantity"]').forEach(btn => {
      btn.addEventListener('click', (e) => self.handleQuantityChange(e, -1));
    });
    cartDrawer.querySelectorAll('[data-action="increase-quantity"]').forEach(btn => {
      btn.addEventListener('click', (e) => self.handleQuantityChange(e, 1));
    });
    cartDrawer.querySelectorAll('[data-action="remove-item"]').forEach(btn => {
      btn.addEventListener('click', (e) => self.handleRemoveItem(e));
    });
  }

  async handleQuantityChange(e, delta) {
    var line = parseInt(e.currentTarget.dataset.line);
    var input = document.querySelector('[data-quantity-input][data-line="' + line + '"]');
    if (!input) return;
    await this.updateCartLine(line, Math.max(0, (parseInt(input.value) || 1) + delta));
  }

  async handleRemoveItem(e) {
    await this.updateCartLine(parseInt(e.currentTarget.dataset.line), 0);
  }

  async updateCartLine(line, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      await this.refreshCartDrawer();
      await this.updateCartCount();
    } catch (error) {
      console.error('Failed to update cart line:', error);
    }
  }

  async updateCartCount() {
    try {
      var response = await fetch('/cart.js');
      var cart = await response.json();
      var cartDisplayCount = Array.isArray(cart.items)
        ? cart.items.reduce(function (count, item) {
            return count + (item.parent_relationship && item.parent_relationship.parent_key ? 0 : (Number(item.quantity) || 0));
          }, 0)
        : (Number(cart.item_count) || 0);
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble').forEach(el => {
        el.textContent = cartDisplayCount;
        if (el.hasAttribute('data-cart-count')) el.dataset.cartCount = cartDisplayCount;
        el.classList.toggle('hidden', cartDisplayCount === 0);
      });
      document.querySelectorAll('.header-actions__cart-icon').forEach(function (icon) {
        icon.classList.toggle('header-actions__cart-icon--has-cart', cartDisplayCount > 0);
      });
    } catch (error) {}
  }

  destroy() {
    if (this.splide) this.splide.destroy();
  }
}

// Init
function initScramblerPDPSections() {
  var sections = document.querySelectorAll('[data-testid="pdp-scrambler-custom-detail"]');
  sections.forEach(function(section) {
    new PDPScramblerDetail(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScramblerPDPSections);
} else {
  initScramblerPDPSections();
}

document.addEventListener('shopify:section:load', function(event) {
  var section = event.target;
  if (section && section.querySelector('[data-testid="pdp-scrambler-custom-detail"]')) {
    new PDPScramblerDetail(section);
  }
});
